<!-- STEP 0: CATEGORY SELECTION VIEW (Customer Memilih Kategori Terlebih Dahulu) -->
<div *ngIf="currentStep === 'select-category'" class="animate-fade-in bg-[#F4F7FF] min-h-screen pb-16">

    <!-- Hero Section -->
    <section class="relative h-[380px] md:h-[420px] bg-cover bg-center overflow-hidden z-10"
        style="background-image: url('/assets/visidea/banner_slide.jpg');">
        <!-- Gradient Overlay -->
        <div class="absolute inset-0 bg-gradient-to-r from-[#1B1E5B]/95 via-[#202367]/85 to-black/75"></div>

        <!-- Content -->
        <div class="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-center items-center text-center text-white space-y-4">
            <h1 class="text-3xl md:text-5xl font-black tracking-tight leading-tight max-w-3xl mx-auto">
                Pilih Kategori <span class="text-emerald-400">Undangan Digital</span> Acaramu
            </h1>
            <p class="text-base md:text-xl text-gray-200 max-w-2xl mx-auto font-light leading-relaxed">
                Silakan pilih kategori kebutuhan acara Anda terlebih dahulu untuk melihat daftar paket & pilihan tema
                yang sesuai.
            </p>
        </div>
    </section>

    <!-- Category Selection Cards Grid (Dynamic loop from API categories) -->
    <section class="py-12 md:py-16 px-6 md:px-12 relative z-20 -mt-10">
        <div class="max-w-7xl mx-auto">

            <div *ngIf="!isLoadingCategories && categories && categories.length > 0"
                class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                <div *ngFor="let cat of categories; let i = index" (click)="chooseCategory(cat.id)"
                    class="group bg-white rounded-3xl p-6 md:p-8 shadow-xl hover:shadow-2xl border-2 border-transparent hover:border-[#202367] transition-all duration-300 cursor-pointer flex flex-col justify-between transform hover:-translate-y-2 relative overflow-hidden">

                    <div *ngIf="cat.badge"
                        class="absolute top-0 right-0 z-10 bg-[#202367] text-white text-[10px] font-black px-3.5 py-1.5 rounded-bl-2xl uppercase tracking-wider shadow-sm">
                        {{ cat.badge }}
                    </div>

                    <div class="space-y-5">
                        <!-- Category Photo Image -->
                        <div class="relative w-full h-52 sm:h-60 rounded-2xl overflow-hidden bg-gray-100 shadow-inner">
                            <img [src]="getCategoryImage(cat)" [alt]="cat.name"
                                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">
                            <div
                                class="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity">
                            </div>
                        </div>

                        <div>
                            <h3
                                class="text-xl md:text-2xl font-black text-[#102B51] group-hover:text-[#202367] transition-colors mb-2 capitalize">
                                {{ cat.name }}
                            </h3>
                            <p class="text-xs md:text-sm text-gray-500 font-medium leading-relaxed">
                                {{ cat.description || getCategoryDefaultDesc(cat.name || cat.id) }}
                            </p>
                        </div>
                    </div>

                    <div class="pt-6 mt-4 border-t border-gray-100">
                        <button
                            class="w-full bg-[#202367] group-hover:bg-emerald-600 text-white font-extrabold py-3.5 px-5 rounded-2xl transition-colors text-xs md:text-sm uppercase tracking-wider flex items-center justify-center gap-2 shadow-md">
                            <span>PILIH {{ cat.name.toUpperCase() }}</span>
                            <span>→</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Loading Skeleton State when fetching categories from API -->
            <div *ngIf="isLoadingCategories || !categories || categories.length === 0"
                class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                <div *ngFor="let _ of [1, 2]"
                    class="bg-white rounded-3xl p-6 md:p-8 shadow-lg border border-gray-100 flex flex-col justify-between space-y-6 animate-pulse">
                    <div class="w-full h-52 sm:h-60 rounded-2xl skeleton-shimmer"></div>
                    <div class="space-y-3">
                        <div class="h-7 w-2/3 rounded-xl skeleton-shimmer"></div>
                        <div class="h-4 w-full rounded-lg skeleton-shimmer"></div>
                        <div class="h-4 w-4/5 rounded-lg skeleton-shimmer"></div>
                    </div>
                    <div class="pt-6 border-t border-gray-100">
                        <div class="h-12 w-full rounded-2xl skeleton-shimmer"></div>
                    </div>
                </div>
            </div>

        </div>
    </section>

</div>

<!-- STEP 1: PACKAGE SELECTION VIEW (Tampilan Pilih Paket) -->
<div *ngIf="currentStep === 'select-package'" class="animate-fade-in">

    <!-- Hero Section -->
    <section class="relative h-[360px] md:h-[400px] bg-cover bg-center overflow-hidden z-10"
        style="background-image: url('/assets/visidea/banner_slide.jpg');">
        <!-- Gradient Overlay -->
        <div class="absolute inset-0 bg-gradient-to-r from-[#1B1E5B]/95 via-[#202367]/85 to-black/70"></div>

        <!-- Content -->
        <div class="relative h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-center items-center text-center text-white space-y-4">
            <h1 class="text-3xl md:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto">
                {{ getCategoryTitle() }}
            </h1>
            <p class="text-base md:text-xl text-gray-200 max-w-2xl mx-auto font-light">
                {{ getCategoryDesc() }}
            </p>
        </div>
    </section>


    <!-- Packages Section with Anchor ID for Auto-Scroll -->
    <section id="pilih-paket-section" class="py-12 md:py-20 px-6 md:px-12 bg-white relative scroll-mt-6">
        <div class="max-w-7xl mx-auto">

            <!-- Header -->
            <div class="text-center space-y-3 mb-12">
                <div
                    class="inline-block bg-[#F4F7FF] text-[#202367] px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-widest">
                    Pricelist Paket Undangan Digital
                </div>
                <h2 class="text-3xl md:text-5xl font-extrabold text-[#102B51]">
                    Pilih Paket {{ getCategoryTitle() }}
                </h2>
                <p class="text-gray-500 text-base md:text-xl max-w-2xl mx-auto">
                    {{ getPackageSectionDesc() }}
                </p>
            </div>

            <!-- Loading Skeleton State for Packages -->
            <div *ngIf="isLoadingPackages || !pricingPackages || pricingPackages.length === 0"
                class="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-12">
                <div *ngFor="let _ of [1, 2, 3]"
                    class="bg-[#F8FAFC] rounded-3xl p-6 border border-gray-100 flex flex-col space-y-6 animate-pulse">
                    <div class="bg-white p-6 rounded-2xl space-y-3">
                        <div class="h-6 w-1/3 rounded-full skeleton-shimmer"></div>
                        <div class="h-8 w-2/3 rounded-xl skeleton-shimmer"></div>
                        <div class="h-10 w-1/2 rounded-xl skeleton-shimmer"></div>
                    </div>
                    <div class="space-y-3 flex-1">
                        <div class="h-4 w-full rounded-lg skeleton-shimmer"></div>
                        <div class="h-4 w-5/6 rounded-lg skeleton-shimmer"></div>
                        <div class="h-4 w-4/6 rounded-lg skeleton-shimmer"></div>
                        <div class="h-4 w-3/4 rounded-lg skeleton-shimmer"></div>
                    </div>
                    <div class="h-14 w-full rounded-full skeleton-shimmer"></div>
                </div>
            </div>

            <!-- Package Cards Grid -->
            <div *ngIf="!isLoadingPackages && pricingPackages && pricingPackages.length > 0"
                class="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-start mb-12">
                <div *ngFor="let pkg of pricingPackages" (click)="choosePackage(pkg.id)"
                    class="bg-[#F8FAFC] border-4 border-transparent hover:border-[#202367] hover:bg-white hover:shadow-2xl hover:scale-105 hover:ring-4 hover:ring-[#202367]/10 rounded-3xl overflow-hidden flex flex-col p-6 transition-all duration-300 relative group cursor-pointer"
                    [ngClass]="{'border-[#202367] ring-4 ring-[#202367]/10': pkg.popular}">

                    <!-- Popular Tag Badge -->
                    <div *ngIf="pkg.popular"
                        class="absolute top-0 right-0 bg-emerald-500 text-white text-xs font-black uppercase px-4 py-1.5 rounded-bl-2xl shadow-md z-10">
                        Best Value
                    </div>

                    <!-- Top Card Content: Title & Price Header (No description between name and price) -->
                    <div
                        class="bg-white border border-gray-100 group-hover:bg-[#F4F7FF] group-hover:border-[#202367]/20 p-6 rounded-2xl mb-6 transition-colors min-h-[120px] flex flex-col justify-center">
                        <span *ngIf="pkg.badge"
                            class="text-xs font-extrabold px-3 py-1 rounded-full uppercase tracking-wider bg-[#202367] text-white inline-block mb-3">
                            {{ pkg.badge }}
                        </span>
                        <h3 class="text-2xl md:text-3xl font-extrabold text-[#102B51] mb-2 capitalize leading-tight">{{
                            pkg.name }}</h3>
                        <div class="text-3xl md:text-4xl font-black text-[#202367]">
                            Rp{{ pkg.price | number }}
                        </div>
                    </div>

                    <!-- Features & Bonus Section (Flex layout to align the line above bonus across all cards) -->
                    <div class="flex-1 flex flex-col justify-between">
                        <!-- Features Checklist & Show More Toggle -->
                        <div class="flex-1 flex flex-col">
                            <ul class="space-y-3">
                                <li *ngFor="let benefit of (pkg.showMore ? pkg.benefits : (pkg.benefits | slice:0:defaultBenefitsLimit))"
                                    class="flex items-start gap-3">
                                    <span class="text-[#202367] text-lg shrink-0">◆</span>
                                    <span class="text-gray-700 text-sm md:text-base font-medium capitalize">{{ benefit
                                        }}</span>
                                </li>
                            </ul>

                            <!-- Show More Toggle Button (h-9 height ensures the line above bonus is horizontally sejajar across cards) -->
                            <div class="h-9 flex items-center justify-start mt-auto pt-2">
                                <button *ngIf="pkg.benefits && pkg.benefits.length > defaultBenefitsLimit" type="button"
                                    (click)="toggleShowMorePackage(pkg, $event)"
                                    class="text-[#202367] hover:text-[#2563EB] text-sm font-semibold italic inline-flex items-center gap-2 transition-colors cursor-pointer py-1">
                                    <span>{{ pkg.showMore ? 'Show Less' : 'Show More' }}</span>
                                    <span
                                        class="w-5 h-5 rounded-full border border-[#202367] flex items-center justify-center transition-transform duration-300 text-[#202367] font-bold text-xs"
                                        [class.rotate-180]="!pkg.showMore">
                                        ↑
                                    </span>
                                </button>
                            </div>
                        </div>

                        <!-- Bottom Section: Aligned Bonus & Order Button (Garis diatas bonus sejajar di semua kartu) -->
                        <div class="mt-auto">
                            <!-- Bonus Section (Garis di atas bonus sejajar) -->
                            <div class="w-full">
                                <div class="w-full border-t-2 border-[#202367] my-4"></div>
                                <div class="text-left w-full mb-6">
                                    <h4 class="text-xl font-bold text-[#202367] mb-1">Bonus</h4>
                                    <p class="text-base sm:text-lg font-semibold text-[#202367]">
                                        {{ pkg.bonus || (pkg.bonuses && pkg.bonuses.length > 0 ? pkg.bonuses[0] : '-')
                                        }}
                                    </p>
                                </div>
                            </div>

                            <!-- CTA Order Button (Original button) -->
                            <div
                                class="w-full bg-[#202367] group-hover:bg-emerald-600 text-white font-extrabold py-4 px-6 rounded-full transition-colors text-base md:text-lg tracking-wide uppercase flex items-center justify-center gap-2 shadow-lg">
                                <span> {{ pkg.name.toUpperCase() }}</span>
                                <span>→</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- Core Features Section -->
    <section class="py-16 md:py-24 px-6 md:px-12 bg-[#F4F7FF]">
        <div class="max-w-7xl mx-auto">
            <div class="text-center space-y-3 mb-16">
                <h2 class="text-2xl md:text-4xl font-extrabold text-[#102B51]">
                    Fitur Lengkap Undangan Digital Visidea
                </h2>
                <p class="text-gray-500 text-base md:text-lg max-w-2xl mx-auto">
                    Semua pilihan paket dibekali fitur canggih buat
                    mempermudah kamu berbagi kabar bahagia ke para
                    tamu undangankapi teknologi terbaik untuk memudahkan penyampaian pesan ke tamu undangan Anda.
                </p>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <div *ngFor="let feat of coreFeatures"
                    class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 space-y-3 group hover:-translate-y-1">
                    <div class="text-4xl p-3 bg-[#F4F7FF] rounded-2xl w-fit group-hover:scale-110 transition-transform">
                        {{ feat.icon }}
                    </div>
                    <h3 class="text-lg font-bold text-[#102B51]">{{ feat.title }}</h3>
                    <p class="text-sm text-gray-500 leading-relaxed">{{ feat.desc }}</p>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- STEP 2: THEMES COLLECTION VIEW (Tampilan Tema Desain Setelah Memilih Paket) -->
<div *ngIf="currentStep === 'select-theme'" class="animate-fade-in bg-[#F4F7FF] min-h-screen">

    <!-- Themes Showcase Section -->
    <section class="py-10 md:py-16 px-6 md:px-12 relative">
        <img src="/assets/visidea/orn_kanan.png"
            class="absolute top-12 right-0 w-24 hidden md:block opacity-60 pointer-events-none" alt="">
        <img src="/assets/visidea/orn_kiri.png"
            class="absolute bottom-12 left-0 w-24 hidden md:block opacity-60 pointer-events-none" alt="">

        <div class="max-w-7xl mx-auto">

            <!-- Clean In-Page Back Navigation & Active Package Tag -->
            <div class="flex flex-wrap items-center justify-between gap-4 mb-8">
                <button (click)="backToPackageSelection()"
                    class="inline-flex items-center gap-2 bg-white hover:bg-gray-100 text-[#102B51] px-5 py-2.5 rounded-full font-bold text-sm shadow-sm border border-gray-200 transition-all cursor-pointer hover:-translate-x-1">
                    <span>←</span>
                    <span>Ganti Paket Undangan</span>
                </button>

                <div class="flex items-center gap-2 bg-white px-4 py-2 rounded-full border border-gray-200 shadow-xs">
                    <span class="text-xs text-gray-500 font-medium">Paket Terpilih:</span>
                    <span class="text-xs font-black text-[#102B51] bg-[#F4F7FF] px-2.5 py-1 rounded-full uppercase">
                        {{ getSelectedPackage().name }} — Rp{{ getSelectedPackage().price | number }}
                    </span>
                </div>
            </div>

            <!-- Header Title -->
            <div class="text-center space-y-3 mb-8">
                <h2 class="text-2xl md:text-4xl font-extrabold text-[#102B51]">
                    Koleksi Tema Desain <span class="text-[#31E986] bg-[#102B51] px-3.5 py-1 rounded-xl shadow-md">{{
                        getCategoryTitle() }}</span>
                </h2>
                <p class="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
                    Pilih tema desain favorit Anda dan sesuaikan dengan konsep acara spesial Anda.
                </p>
            </div>

            <!-- Filter Section (Theme Sub-Categories) -->
            <div class="space-y-4 mb-10 max-w-6xl mx-auto">
                <!-- 1. Theme Concept / Category Filter -->
                <div class="flex flex-wrap items-center justify-center gap-2 md:gap-2.5">
                    <button *ngFor="let filter of themeCategoryFilters" (click)="setThemeCategoryFilter(filter.id)"
                        [ngClass]="activeThemeCategory === filter.id 
                            ? 'bg-[#202367] text-white shadow-lg shadow-[#202367]/25 font-extrabold scale-105 border-[#202367]' 
                            : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-200 font-semibold hover:border-gray-300'"
                        class="px-4 py-2 rounded-full text-xs md:text-sm border transition-all duration-200 flex items-center gap-1.5 cursor-pointer shadow-xs">
                        <span>{{ filter.label }}</span>
                    </button>
                </div>
            </div>

            <!-- Loading Skeleton State for Themes (Phone Mockup Shape - 4 Columns) -->
            <div *ngIf="isLoadingThemes || !allThemes || allThemes.length === 0"
                class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-6 mb-12 justify-items-center">
                <div *ngFor="let _ of [1, 2, 3, 4]"
                    class="w-full max-w-[210px] sm:max-w-[220px] flex flex-col items-center animate-pulse">
                    <div
                        class="relative w-full aspect-[9/16] rounded-[24px] skeleton-shimmer overflow-hidden shadow-md">
                    </div>
                    <div class="h-4 w-3/4 rounded-lg skeleton-shimmer mt-3 mb-2"></div>
                    <div class="w-full space-y-1.5">
                        <div class="grid grid-cols-2 gap-1.5">
                            <div class="h-8 rounded-lg skeleton-shimmer"></div>
                            <div class="h-8 rounded-lg skeleton-shimmer"></div>
                        </div>
                        <div class="h-8 rounded-lg skeleton-shimmer"></div>
                    </div>
                </div>
            </div>

            <!-- Empty Filter State -->
            <div *ngIf="!isLoadingThemes && allThemes && allThemes.length > 0 && getFilteredThemes().length === 0"
                class="text-center py-16 bg-white rounded-3xl border border-gray-100 shadow-sm max-w-md mx-auto p-8 space-y-4">
                <div
                    class="w-16 h-16 rounded-full bg-[#F4F7FF] flex items-center justify-center mx-auto text-[#202367]">
                    <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
                <h3 class="text-lg font-bold text-[#102B51]">Tema Belum Tersedia</h3>
                <p class="text-xs text-gray-500">
                    Belum ada tema desain untuk kategori filter ini. Silakan pilih kategori filter lainnya.
                </p>
                <button (click)="setThemeCategoryFilter('all')"
                    class="px-5 py-2.5 bg-[#202367] text-white rounded-full text-xs font-bold shadow-md hover:bg-[#151745] transition cursor-pointer">
                    Tampilkan Semua Tema
                </button>
            </div>

            <!-- Grid Cards Layout (Clean Standalone Phone Mockup with Decoupled Buttons & Dual Image Hover) -->
            <div *ngIf="!isLoadingThemes && allThemes && allThemes.length > 0 && getFilteredThemes().length > 0"
                class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-6 xl:gap-8 justify-items-center">

                <div *ngFor="let theme of getFilteredThemes()"
                    class="w-full max-w-[210px] sm:max-w-[220px] flex flex-col items-center group relative">

                    <!-- 1. Standalone Phone Preview Container (Free-standing phone mockup with natural shadow & hover lift) -->
                    <div
                        class="relative w-full aspect-[9/16] transition-all duration-500 transform group-hover:-translate-y-2 select-none">

                        <!-- Distinctive Floating Pill/Badge for Custom Request (Matching Web Palette) -->
                        <div *ngIf="theme.isCustomEvent || theme.id === 805"
                            class="absolute -top-2.5 left-1/2 -translate-x-1/2 z-30 flex items-center justify-center">
                            <div
                                class="relative flex items-center gap-1 bg-[#202367] text-white text-[9px] sm:text-[10px] font-extrabold px-3 py-1 rounded-full shadow-[0_4px_12px_rgba(32,35,103,0.35)] border border-white/40 ring-1 ring-[#102B51]">
                                <span class="tracking-wider uppercase">CUSTOM EVENT</span>
                            </div>
                        </div>

                        <!-- Outer clipping and shadow wrapping matching phone silhouette -->
                        <div class="relative w-full h-full rounded-[24px] overflow-hidden transition-all duration-500 bg-transparent"
                            [ngClass]="(theme.isCustomEvent || theme.id === 805) 
                                ? 'ring-2 ring-[#202367]/50 drop-shadow-[0_14px_28px_rgba(32,35,103,0.22)] group-hover:drop-shadow-[0_22px_38px_rgba(32,35,103,0.35)]' 
                                : 'drop-shadow-[0_12px_24px_rgba(0,0,0,0.14)] group-hover:drop-shadow-[0_20px_35px_rgba(32,35,103,0.25)]'">
                            <!-- Primary Cover Image (Image 1) -->
                            <img [src]="theme.image" [alt]="theme.title"
                                class="absolute inset-0 w-full h-full object-contain transition-all duration-700"
                                [ngClass]="theme.hoverImage ? 'group-hover:opacity-0 group-hover:scale-105' : 'group-hover:scale-105'">

                            <!-- Secondary Hover Image (Image 2 - switches smoothly on hover when available) -->
                            <img *ngIf="theme.hoverImage" [src]="theme.hoverImage" [alt]="theme.title + ' preview 2'"
                                class="absolute inset-0 w-full h-full object-contain opacity-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700">
                        </div>

                    </div>

                    <!-- 2. Separate Title Label below Phone -->
                    <div class="w-full text-center mt-2.5 mb-2 px-1">
                        <h3
                            class="text-[#102B51] font-extrabold text-xs sm:text-sm line-clamp-1 group-hover:text-[#202367] transition-colors">
                            {{ theme.title }}
                        </h3>
                    </div>

                    <!-- 3. Separate Action Buttons Section (Completely decoupled from the phone graphic) -->
                    <div class="w-full space-y-1.5">
                        <!-- Custom Event Theme: Single Full-Width "Custom" Button -->
                        <div *ngIf="theme.isCustomEvent || theme.id === 805" class="w-full">
                            <button (click)="openThemeDetail(theme)"
                                class="w-full py-2.5 px-3 rounded-xl bg-[#202367] hover:bg-[#151745] active:scale-[0.98] text-white font-bold text-xs sm:text-sm transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-1.5 cursor-pointer">
                                <span>Custom</span>
                                <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </button>
                        </div>

                        <!-- Standard Themes: Demo, Pilih & Keranjang Buttons -->
                        <ng-container *ngIf="!theme.isCustomEvent && theme.id !== 805">
                            <div class="grid grid-cols-2 gap-1.5">
                                <button (click)="openDemoModal(theme)"
                                    class="w-full py-2 px-1 rounded-lg bg-white hover:bg-gray-50 text-[#102B51] font-bold text-[11px] sm:text-xs transition-all text-center cursor-pointer border border-gray-200 shadow-xs hover:shadow-sm flex items-center justify-center gap-1 active:scale-[0.98]">
                                    <svg class="w-3 h-3 text-[#202367] shrink-0" fill="none" stroke="currentColor"
                                        viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                    </svg>
                                    <span>Demo</span>
                                </button>
                                <button (click)="openThemeDetail(theme)"
                                    class="w-full py-2 px-1 rounded-lg bg-[#202367] hover:bg-[#151745] text-white font-bold text-[11px] sm:text-xs transition-all shadow-sm hover:shadow-md text-center cursor-pointer flex items-center justify-center gap-1 active:scale-[0.98]">
                                    <span>Pilih</span>
                                    <svg class="w-3 h-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                            <!-- Add to Cart Button -->
                            <button (click)="addToCart(theme, $event)"
                                class="w-full py-2 px-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 active:scale-[0.98] text-white font-bold text-[11px] sm:text-xs transition-all shadow-sm hover:shadow-md flex items-center justify-center gap-1.5 cursor-pointer">
                                <svg class="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <span>Keranjang</span>
                            </button>
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
    </section>
</div>

<!-- STEP 3: THEME DETAIL & CUSTOMIZATION VIEW (Halaman Konfigurasi Tema & Live Preview) -->
<div *ngIf="currentStep === 'theme-detail'" class="animate-fade-in bg-[#F4F7FF] min-h-screen">

    <!-- Top Sticky Bar -->
    <section class="bg-gradient-to-r from-[#1B1E5B] to-[#202367]
           py-3 px-6 md:px-12
           text-white shadow-md
           sticky top-0 z-40
           backdrop-blur-md">
        <div class="max-w-7xl mx-auto flex flex-col gap-3">
            <button (click)="backToThemeSelection()"
                class="self-start flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full font-bold text-sm transition-all border border-white/20 cursor-pointer">
                <span>←</span>
                <span>Kembali ke Pilih Tema</span>
            </button>

            <div class="flex flex-col sm:flex-row sm:items-end justify-between gap-2 sm:gap-4">
                <div class="min-w-0">
                    <span class="block text-xs font-bold uppercase text-emerald-300 tracking-wider">Detail &amp;
                        Customization Tema</span>
                    <h2 class="text-base md:text-xl font-extrabold text-white leading-snug break-words">
                        {{ selectedTheme?.title }} — <span class="text-emerald-300">{{ getSelectedPackage().name
                            }}</span>
                    </h2>
                </div>

                <span class="bg-emerald-500 text-white text-xs font-black px-3 py-1.5 rounded-full uppercase shadow-sm">
                    Total: Rp{{ calculateTotalPrice() | number }}
                </span>
            </div>
        </div>
    </section>

    <!-- Main Detail Layout (3-Column Grid) -->
    <div class="max-w-7xl mx-auto px-6 md:px-12 py-10">

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

            <!-- LEFT COLUMN: Theme Summary & Order Card (lg:col-span-4) -->
            <div
                class="lg:col-span-4 bg-white rounded-3xl p-6 shadow-xl border border-gray-100 space-y-6 relative overflow-hidden">

                <!-- Badge Ribbons -->
                <div *ngIf="selectedTheme?.badge || selectedTheme?.tag"
                    class="flex justify-between items-center border-b border-gray-100 pb-4">
                    <span *ngIf="selectedTheme?.badge"
                        class="bg-[#202367] text-white text-xs font-extrabold px-3 py-1 rounded-full uppercase tracking-wider">
                        {{ selectedTheme?.badge }}
                    </span>
                    <span *ngIf="selectedTheme?.tag"
                        class="text-xs text-gray-500 font-semibold bg-[#F4F7FF] px-3 py-1 rounded-full">
                        {{ selectedTheme?.tag }}
                    </span>
                </div>

                <!-- Title & Base Pricing -->
                <div>
                    <h2 class="text-3xl font-black text-[#102B51] mb-1">{{ selectedTheme?.title }}</h2>
                    <p class="text-xs text-gray-500 font-medium">Paket dasar: <strong class="text-[#202367]">{{
                            getSelectedPackage().name }}</strong></p>

                    <div class="mt-4 p-4 bg-[#F4F7FF] rounded-2xl border border-gray-100">
                        <div class="flex justify-between items-center text-sm text-gray-600 mb-1">
                            <span>Harga Paket Dasar:</span>
                            <span class="font-bold text-[#102B51]">Rp{{ getSelectedPackage().price | number }}</span>
                        </div>
                        <div *ngIf="calculateAddonsTotal() > 0"
                            class="flex justify-between items-center text-sm text-emerald-600 mb-1">
                            <span>Total Add-On (+):</span>
                            <span class="font-bold">+Rp{{ calculateAddonsTotal() | number }}</span>
                        </div>
                        <div class="border-t border-gray-200 pt-2 mt-2 flex justify-between items-center">
                            <span class="font-extrabold text-sm text-[#102B51]">Total Keseluruhan:</span>
                            <span class="text-2xl font-black text-[#202367]">Rp{{ calculateTotalPrice() | number
                                }}</span>
                        </div>
                    </div>
                </div>

                <!-- Included Features List -->
                <div class="space-y-3">
                    <h4 class="text-xs font-extrabold uppercase tracking-wider text-gray-400">Fitur Utama Termasuk:</h4>
                    <ul class="space-y-2">
                        <li *ngFor="let feat of (getSelectedPackage().benefits && getSelectedPackage().benefits.length > 0 ? getSelectedPackage().benefits : selectedTheme?.features)"
                            class="flex items-center gap-2.5 text-sm text-gray-700">
                            <span
                                class="w-5 h-5 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center text-xs font-bold shrink-0">✓</span>
                            <span class="capitalize">{{ feat }}</span>
                        </li>
                    </ul>
                </div>

                <!-- Active Addons Summary -->
                <div *ngIf="getSelectedAddonsList().length > 0"
                    class="space-y-2 bg-emerald-50 p-4 rounded-2xl border border-emerald-100">
                    <div class="flex justify-between items-center mb-1">
                        <h4 class="text-xs font-extrabold uppercase tracking-wider text-emerald-800">Add-On Yang
                            Dipilih:</h4>
                        <span class="text-[10px] text-emerald-600 font-semibold">Klik ✕ untuk batalkan</span>
                    </div>
                    <ul class="space-y-2 text-xs text-emerald-700 font-medium">
                        <li *ngFor="let addon of getSelectedAddonsList()"
                            class="flex justify-between items-center bg-white p-2.5 rounded-xl border border-emerald-200/60 shadow-2xs">
                            <span class="truncate pr-2">
                                • {{ addon.addonObj.name }}
                                <strong *ngIf="addon.addonObj.hasQuantity" class="text-emerald-900">({{ addon.qty }} {{
                                    addon.addonObj.unit }})</strong>
                            </span>
                            <div class="flex items-center gap-2 shrink-0">
                                <span class="font-bold text-[#202367]">+Rp{{ addon.totalPrice | number }}</span>
                                <button (click)="removeAddonFromMap(addon.addonObj.id, $event)" title="Batalkan Add On"
                                    class="w-5 h-5 rounded-full bg-rose-100 text-rose-600 hover:bg-rose-600 hover:text-white flex items-center justify-center font-bold text-xs transition-colors cursor-pointer">
                                    ✕
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- Action Buttons (Add to Cart & Checkout) -->
                <div class="space-y-2.5">
                    <button (click)="goToCheckout()"
                        class="w-full bg-[#202367] hover:bg-[#1a1d52] text-white font-extrabold py-3.5 px-6 rounded-2xl shadow-xl hover:shadow-2xl transition-all text-sm md:text-base flex items-center justify-center gap-2 uppercase cursor-pointer transform hover:-translate-y-0.5 group">
                        <span>Lanjut ke Checkout</span>
                        <span class="group-hover:translate-x-1 transition-transform">→</span>
                    </button>

                    <button (click)="addToCart(selectedTheme)"
                        class="w-full bg-emerald-600 hover:bg-emerald-700 active:scale-[0.98] text-white font-bold py-3 px-4 rounded-2xl shadow-md transition-all text-xs md:text-sm flex items-center justify-center gap-2 cursor-pointer">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span>Masukan Tema ke Keranjang</span>
                    </button>
                </div>

                <!-- Mascot Badge -->
                <div class="flex items-center gap-3 bg-[#F4F7FF] p-3 rounded-2xl border border-gray-100">
                    <img src="/assets/visidea/icon/icon-beruang.png" class="w-10 h-10 object-contain shrink-0"
                        alt="Mascot">
                    <p class="text-[11px] text-gray-500 leading-tight">
                        Pemesanan diproses secara otomatis & langsung terhubung dengan pembayaran QRIS.
                    </p>
                </div>
            </div>

            <!-- CENTER COLUMN: Interactive Theme Images Preview (lg:col-span-4) -->
            <div class="lg:col-span-4 flex flex-col items-center justify-center space-y-4">

                <!-- Image / Carousel Container (Clean without phone frame, transparent background like product list) -->
                <div
                    class="w-full max-w-[280px] sm:max-w-[320px] aspect-[9/16] bg-transparent rounded-3xl relative group select-none flex items-center justify-center">

                    <ng-container *ngIf="getThemePreviewImages(selectedTheme) as previewImgs">
                        <div
                            class="w-full h-full relative overflow-hidden rounded-[24px] drop-shadow-[0_12px_28px_rgba(0,0,0,0.15)] flex items-center justify-center">
                            <img [src]="previewImgs[activePreviewImageIndex] || selectedTheme?.image || '/assets/visidea/theme-1.jpg'"
                                [alt]="selectedTheme?.title"
                                class="w-full h-full object-contain transition-all duration-500">
                        </div>

                        <!-- Carousel Controls (if > 1 image) -->
                        <ng-container *ngIf="previewImgs.length > 1">
                            <!-- Left Chevron -->
                            <button (click)="prevPreviewImage(previewImgs.length)"
                                class="absolute -left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-[#102B51]/80 hover:bg-[#202367] text-white flex items-center justify-center backdrop-blur-md transition-all opacity-90 hover:opacity-100 cursor-pointer shadow-xl z-20 border border-white/20">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                        d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>

                            <!-- Right Chevron -->
                            <button (click)="nextPreviewImage(previewImgs.length)"
                                class="absolute -right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-[#102B51]/80 hover:bg-[#202367] text-white flex items-center justify-center backdrop-blur-md transition-all opacity-90 hover:opacity-100 cursor-pointer shadow-xl z-20 border border-white/20">
                                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                        d="M9 5l7 7-7 7" />
                                </svg>
                            </button>

                            <!-- Pagination Dots -->
                            <div
                                class="absolute -bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-[#102B51]/70 backdrop-blur-md px-3 py-1.5 rounded-full z-20 border border-white/10 shadow-md">
                                <button *ngFor="let img of previewImgs; let idx = index"
                                    (click)="setPreviewImageIndex(idx)"
                                    [ngClass]="activePreviewImageIndex === idx ? 'w-5 bg-[#31E986]' : 'w-2 bg-white/60 hover:bg-white'"
                                    class="h-2 rounded-full transition-all duration-300 cursor-pointer"></button>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>

                <!-- Fullscreen Demo Button -->
                <button (click)="openDemoModal(selectedTheme)"
                    class="bg-[#202367] hover:bg-[#1a1d52] text-white font-bold px-6 py-2.5 rounded-full text-xs md:text-sm shadow-md transition-colors flex items-center gap-2 cursor-pointer">
                    <svg class="w-4 h-4 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                    <span>Buka Tampilan Demo HP</span>
                </button>
            </div>

            <!-- RIGHT COLUMN: Customization Options (lg:col-span-4) -->
            <div class="lg:col-span-4 space-y-6">

                <!-- 1. Detail Tema Concept -->
                <div class="bg-white rounded-3xl p-6 shadow-md border border-gray-100 space-y-3">
                    <h3 class="text-lg font-black text-[#102B51] flex items-center gap-2">
                        <span>Detail Tema</span>
                    </h3>
                    <p class="text-xs text-gray-600 leading-relaxed font-medium">
                        {{ selectedTheme?.description || selectedTheme?.short_description || ('Tema ' +
                        (selectedTheme?.title || '') + ' mengusung tata letak modern yang responsif. Seluruh nama
                        pasangan, tanggal acara, galeri foto, musik backsound, dan navigasi lokasi dapat disesuaikan
                        penuh.') }}
                    </p>
                </div>

                <!-- 2. Pilihan Agama (Religion Presets) -->
                <div class="bg-white rounded-3xl p-6 shadow-md border border-gray-100 space-y-3">
                    <div class="flex justify-between items-center">
                        <h3 class="text-sm font-extrabold text-[#102B51] uppercase tracking-wider">
                            Pilihan Agama <span class="text-rose-500">*</span>
                        </h3>
                        <span class="text-[11px] text-gray-400 font-medium">Salam & Doa</span>
                    </div>
                    <div class="flex flex-wrap gap-2">
                        <button *ngFor="let rel of religions" (click)="selectedReligion = rel.id"
                            [ngClass]="selectedReligion === rel.id ? 'bg-[#202367] text-white shadow-md font-bold' : 'bg-[#F4F7FF] text-gray-700 hover:bg-gray-200 font-medium'"
                            class="px-3 py-1.5 rounded-full text-xs transition-all cursor-pointer">
                            {{ rel.label }}
                        </button>
                    </div>
                </div>



                <!-- 4. Add On Fitur Undangan Digital (Modern Checkbox-Free iOS Toggle UI) -->
                <div class="bg-white rounded-3xl p-6 shadow-md border border-gray-100 space-y-4">
                    <div class="flex justify-between items-center">
                        <div>
                            <h3 class="text-sm font-black text-[#102B51] uppercase tracking-wider">
                                Add On Fitur Extra
                            </h3>
                            <p class="text-[11px] text-gray-400 font-medium">Klik fitur untuk mengaktifkan</p>
                        </div>
                        <span
                            class="text-xs bg-emerald-500/10 text-emerald-600 font-extrabold px-3 py-1 rounded-full border border-emerald-500/20">
                            {{ getSelectedAddonsList().length }} Aktif
                        </span>
                    </div>

                    <div class="space-y-3 max-h-[360px] overflow-y-auto pr-1 scrollbar-hide">
                        <div *ngFor="let addon of getAvailableAddonsForCurrentCategory()"
                            (click)="clickAddonCard(addon)"
                            [ngClass]="isAddonSelected(addon.id)
                                ? 'bg-gradient-to-r from-[#102B51] to-[#202367] text-white shadow-xl scale-[1.02] border-2 border-[#31E986]/40'
                                : 'bg-[#F8FAFC] hover:bg-white text-gray-800 border border-gray-100 hover:border-gray-300 hover:shadow-md'"
                            class="p-4 rounded-2xl transition-all duration-300 cursor-pointer flex items-center justify-between gap-3 group relative overflow-hidden">

                            <!-- Left Info (Icon removed) -->
                            <div class="min-w-0 flex-1">
                                <div class="flex items-center gap-2">
                                    <h4 [ngClass]="isAddonSelected(addon.id) ? 'text-white' : 'text-[#102B51]'"
                                        class="text-xs font-extrabold truncate transition-colors">
                                        {{ addon.name }}
                                    </h4>
                                </div>
                                <p [ngClass]="isAddonSelected(addon.id) ? 'text-gray-300' : 'text-gray-500'"
                                    class="text-[11px] leading-snug mt-0.5 transition-colors line-clamp-1">
                                    {{ addon.desc }}
                                </p>
                            </div>

                            <!-- Right Price Badge -->
                            <div class="flex items-center gap-2 shrink-0">
                                <span
                                    [ngClass]="isAddonSelected(addon.id) ? 'text-[#31E986] bg-emerald-500/20 border-emerald-400/30' : 'text-[#202367] bg-white border-gray-200'"
                                    class="text-xs font-black px-3 py-1.5 rounded-full border shadow-2xs transition-colors text-right">
                                    +Rp{{ (addon.hasQuantity ? (selectedAddonsMap[addon.id]?.totalPrice ||
                                    (addon.unitPrice * (addon.defaultQty || 1))) : addon.unitPrice) | number }}
                                    <span *ngIf="addon.hasQuantity && isAddonSelected(addon.id)"
                                        class="text-[10px] font-bold text-emerald-300 block">
                                        ({{ getAddonQty(addon.id) }} {{ addon.unit }})
                                    </span>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>

<!-- STEP 4: CHECKOUT & DETAIL PEMESANAN VIEW -->
<div *ngIf="currentStep === 'checkout'" class="animate-fade-in bg-[#F4F7FF] min-h-screen">

    <!-- Top Sticky Bar -->
    <section
        class="bg-gradient-to-r from-[#1B1E5B] to-[#202367] py-4 px-6 md:px-12 text-white shadow-md sticky top-[128px] z-40 backdrop-blur-md">
        <div class="max-w-7xl mx-auto flex items-center justify-between gap-4">
            <div class="flex items-center gap-4">
                <button (click)="backToThemeDetail()"
                    class="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full font-bold text-sm transition-all border border-white/20 cursor-pointer">
                    <span>←</span>
                    <span>Kembali ke Custom Tema</span>
                </button>

                <div>
                    <h2 class="text-lg md:text-xl font-extrabold text-white">
                        Detail Pemesanan Undangan Digital
                    </h2>
                </div>
            </div>

            <div class="hidden sm:flex items-center gap-3">
                <span
                    class="bg-emerald-500 text-white text-xs font-black px-3.5 py-1.5 rounded-full uppercase shadow-sm">
                    Total: Rp{{ calculateFinalTotal() | number }}
                </span>
            </div>
        </div>
    </section>

    <!-- Main Checkout Content (2-Column Grid) -->
    <div class="max-w-7xl mx-auto px-6 md:px-12 py-10">

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

            <!-- LEFT COLUMN: Form Data Pemesan, Voucher & Actions (lg:col-span-7) -->
            <div class="lg:col-span-7 space-y-6">

                <!-- 1. Form Data Pemesan Card -->
                <div class="bg-white rounded-3xl p-6 sm:p-8 shadow-xl border border-gray-100 space-y-5">
                    <div class="border-b border-gray-100 pb-4 flex items-center justify-between">
                        <div>
                            <h3 class="text-xl font-extrabold text-[#102B51]">Data Pemesan</h3>
                            <p class="text-xs text-gray-400 font-medium mt-0.5">Isi data pemesan untuk pembuatan dokumen
                                pesanan undangan</p>
                        </div>
                    </div>

                    <div class="space-y-4">
                        <!-- Email Field (Wajib diisi & Wajib mengandung '@') -->
                        <div>
                            <label class="block text-xs font-extrabold text-[#102B51] uppercase tracking-wider mb-1.5">
                                Alamat Email <span class="text-rose-500">*</span>
                            </label>
                            <input type="email" [(ngModel)]="customerEmail" (input)="onEmailInput()"
                                (blur)="onEmailBlur()" placeholder="Contoh: anindita@gmail.com"
                                [ngClass]="showEmailError() ? 'border-rose-500 ring-2 ring-rose-500/20 bg-rose-50/10' : 'border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20'"
                                class="w-full px-4 py-3.5 rounded-2xl border text-sm font-medium transition-all outline-none">

                            <!-- Display Empty Error if form submitted and email is empty -->
                            <p *ngIf="showEmailEmptyError()"
                                class="text-xs text-rose-500 mt-1 font-semibold flex items-center gap-1">
                                <span>⚠️</span>
                                <span>Alamat email wajib diisi.</span>
                            </p>

                            <!-- Display Format Error if email filled without '@' and user moved to another field/submitted -->
                            <p *ngIf="showEmailFormatError()"
                                class="text-xs text-rose-500 mt-1 font-semibold flex items-center gap-1">
                                <span>⚠️</span>
                                <span>Mohon isi format email dengan benar.</span>
                            </p>
                        </div>

                        <!-- Nama Lengkap (Focus/input triggers email validation) -->
                        <div>
                            <label class="block text-xs font-extrabold text-[#102B51] uppercase tracking-wider mb-1.5">
                                Nama Lengkap <span class="text-rose-500">*</span>
                            </label>
                            <input type="text" [(ngModel)]="customerName" (focus)="onOtherFieldFocus()"
                                (input)="onOtherFieldFocus()" placeholder="Contoh: Anindita & Wira"
                                [ngClass]="formSubmitted && !customerName.trim() ? 'border-rose-500 ring-2 ring-rose-500/20' : 'border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20'"
                                class="w-full px-4 py-3.5 rounded-2xl border text-sm font-medium transition-all outline-none">
                            <p *ngIf="formSubmitted && !customerName.trim()"
                                class="text-xs text-rose-500 mt-1 font-semibold">
                                Nama pemesan wajib diisi.
                            </p>
                        </div>

                        <!-- No Handphone / WhatsApp (Focus/input triggers email validation) -->
                        <div>
                            <label class="block text-xs font-extrabold text-[#102B51] uppercase tracking-wider mb-1.5">
                                No. Handphone / WhatsApp <span class="text-rose-500">*</span>
                            </label>
                            <input type="tel" [(ngModel)]="customerPhone" (focus)="onOtherFieldFocus()"
                                (keydown)="onPhoneKeydown($event)" (input)="onPhoneInput($event); onOtherFieldFocus()"
                                placeholder="Contoh: 081234567890"
                                [ngClass]="formSubmitted && !customerPhone.trim() ? 'border-rose-500 ring-2 ring-rose-500/20' : 'border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20'"
                                class="w-full px-4 py-3.5 rounded-2xl border text-sm font-medium transition-all outline-none">
                            <p *ngIf="formSubmitted && !customerPhone.trim()"
                                class="text-xs text-rose-500 mt-1 font-semibold">
                                Nomor WhatsApp aktif wajib diisi (hanya angka).
                            </p>
                        </div>
                    </div>
                </div>

                <!-- 2. Promo atau Voucher Card -->
                <div class="bg-white rounded-3xl p-6 sm:p-8 shadow-xl border border-gray-100 space-y-4">
                    <h3 class="text-lg font-extrabold text-[#102B51] flex items-center gap-2">
                        <span>🏷️</span>
                        <span>Promo atau Voucher</span>
                    </h3>

                    <div class="flex flex-col sm:flex-row items-center gap-3">
                        <input type="text" [(ngModel)]="voucherCode" (focus)="emailTouched = true"
                            placeholder="Masukkan Kode Promo (contoh: VISIDEA2026)"
                            class="w-full sm:flex-1 px-4 py-3 rounded-2xl border border-gray-200 focus:border-[#202367] uppercase font-bold text-sm outline-none">
                        <button (click)="applyVoucher()"
                            class="w-full sm:w-auto px-6 py-3 bg-[#202367] hover:bg-[#1a1d52] text-white font-extrabold rounded-2xl text-sm transition-colors cursor-pointer uppercase shrink-0">
                            Gunakan
                        </button>
                    </div>

                    <!-- Voucher Banners -->
                    <div *ngIf="voucherSuccessMsg"
                        class="p-3 bg-emerald-50 border border-emerald-200 rounded-2xl flex items-center justify-between text-xs text-emerald-800 font-bold">
                        <span>✓ {{ voucherSuccessMsg }}</span>
                        <button (click)="removeVoucher()"
                            class="text-rose-600 hover:underline font-extrabold text-[11px] cursor-pointer">
                            Hapus
                        </button>
                    </div>

                    <div *ngIf="voucherErrorMsg"
                        class="p-3 bg-rose-50 border border-rose-200 rounded-2xl text-xs text-rose-700 font-bold">
                        ✕ {{ voucherErrorMsg }}
                    </div>
                </div>

                <!-- 3. Persetujuan Syarat & Ketentuan Checkbox -->
                <div class="bg-white rounded-3xl p-6 shadow-md border border-gray-100 space-y-3">
                    <label class="flex items-start gap-3 cursor-pointer select-none">
                        <input type="checkbox" [(ngModel)]="agreeTerms"
                            class="w-5 h-5 rounded border-gray-300 text-[#202367] focus:ring-[#202367] mt-0.5 cursor-pointer">
                        <span class="text-xs text-gray-700 font-medium leading-relaxed">
                            Saya telah membaca dan menyetujui <strong class="text-[#202367]">Syarat Ketentuan &
                                Kebijakan Privasi</strong> pembuatan undangan digital Visidea Studio. *
                        </span>
                    </label>

                    <p *ngIf="formSubmitted && !agreeTerms" class="text-xs text-rose-500 font-bold pl-8">
                        Silakan centang persetujuan syarat dan ketentuan di atas.
                    </p>
                </div>

                <!-- 4. Final Action Button (Buat Pesanan) -->
                <div class="space-y-3">
                    <button (click)="submitOrder()"
                        class="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-black py-4 px-6 rounded-2xl shadow-xl hover:shadow-2xl transition-all text-base md:text-lg flex items-center justify-center uppercase cursor-pointer transform hover:-translate-y-1">
                        <span>Buat Pesanan</span>
                    </button>

                    <div class="flex items-center justify-center gap-2 text-xs text-gray-500">
                        <span>🔒</span>
                        <span>Transaksi aman & terhubung langsung dengan IT Support Visidea Studio</span>
                    </div>
                </div>

            </div>

            <!-- RIGHT COLUMN: Order Summary & Visual Card (lg:col-span-5) -->
            <div class="lg:col-span-5 space-y-6">

                <!-- Selected Theme Card Preview (Creative Mockup + Features Checklist) -->
                <div
                    class="bg-white rounded-3xl p-6 shadow-xl border border-gray-100 space-y-5 relative overflow-hidden">

                    <!-- Dynamic Top Header with Price -->
                    <div class="flex items-start justify-between border-b border-gray-100 pb-4">
                        <div>
                            <div class="flex items-center gap-2 mb-1">
                                <span
                                    class="text-xs font-black uppercase px-3 py-1 rounded-full bg-[#202367] text-white">
                                    {{ getSelectedPackage().name }}
                                </span>
                                <span class="text-xs font-bold text-gray-500 bg-[#F4F7FF] px-2.5 py-1 rounded-full">
                                    {{ selectedTheme?.tag }}
                                </span>
                            </div>
                            <h3 class="text-2xl font-black text-[#102B51]">{{ selectedTheme?.title }}</h3>
                        </div>

                        <!-- Price Pill Tag -->
                        <div class="text-right">
                            <span class="text-xs text-gray-400 line-through font-semibold block">
                                Rp{{ (getSelectedPackage().price * 1.3) | number }}
                            </span>
                            <span class="text-xl font-black text-emerald-600">
                                Rp{{ calculateFinalTotal() | number }}
                            </span>
                        </div>
                    </div>

                    <!-- Side-by-Side Content: Mockup + Checklist -->
                    <div class="grid grid-cols-1 sm:grid-cols-12 gap-5 items-center">

                        <!-- Left: Smartphone Mockup Frame (sm:col-span-5) -->
                        <div class="sm:col-span-5 flex justify-center">
                            <div
                                class="w-[150px] bg-slate-900 rounded-[32px] p-2 shadow-xl border-2 border-slate-700 relative overflow-hidden group">
                                <div
                                    class="w-full h-[250px] bg-white rounded-[24px] overflow-hidden relative border border-slate-800 flex flex-col justify-between">
                                    <div class="absolute inset-0 z-10">
                                        <img [src]="selectedTheme?.image" [alt]="selectedTheme?.title"
                                            class="w-full h-full object-cover">
                                        <div
                                            class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent">
                                        </div>
                                    </div>

                                    <div class="relative z-20 p-3 text-white text-center space-y-1 pt-12">
                                        <span
                                            class="text-[8px] uppercase font-bold text-emerald-300 bg-black/40 px-2 py-0.5 rounded-full">
                                            {{ getReligionPreset().label }}
                                        </span>
                                        <h4 class="text-xs font-black font-serif tracking-wide truncate">ANINDITA & WIRA
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Right: Metadata & Included Features List (sm:col-span-7) -->
                        <div class="sm:col-span-7 space-y-4">
                            <!-- Preset Badges -->
                            <div class="flex flex-wrap gap-2">
                                <span
                                    class="text-xs md:text-sm font-extrabold bg-[#F4F7FF] text-[#202367] px-3.5 py-1.5 rounded-xl border border-gray-200/80 shadow-2xs">
                                    🙏 {{ getReligionPreset().label }}
                                </span>
                            </div>

                            <!-- Fitur yang Tersedia Checklist -->
                            <div class="space-y-2.5 bg-[#F8FAFC] p-4 rounded-2xl border border-gray-100">
                                <h4 class="text-sm font-extrabold text-[#102B51]">Fitur yang tersedia:</h4>
                                <ul
                                    class="space-y-2 text-xs md:text-sm text-gray-800 font-semibold max-h-[180px] overflow-y-auto pr-1">
                                    <li *ngFor="let feat of selectedTheme?.features" class="flex items-center gap-2.5">
                                        <span
                                            class="w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center text-xs font-black shrink-0 shadow-xs">✓</span>
                                        <span class="truncate">{{ feat }}</span>
                                    </li>
                                    <li *ngFor="let addon of getSelectedAddonsList()"
                                        class="flex items-center gap-2.5 text-emerald-800 font-bold">
                                        <span
                                            class="w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center text-xs font-black shrink-0 shadow-xs">✓</span>
                                        <span class="truncate">{{ addon.addonObj.name }} <strong
                                                *ngIf="addon.addonObj.hasQuantity">({{ addon.qty }} {{
                                                addon.addonObj.unit }})</strong></span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Ringkasan Pesanan (Rincian Biaya Breakdown) -->
                <div class="bg-white rounded-3xl p-6 shadow-xl border border-gray-100 space-y-4">
                    <h3 class="text-lg font-black text-[#102B51] border-b border-gray-100 pb-3">
                        Ringkasan Pesanan
                    </h3>

                    <div class="space-y-2.5 text-sm">
                        <!-- Paket Dasar -->
                        <div class="flex justify-between items-center text-gray-600">
                            <span>Harga {{ getSelectedPackage().name }}</span>
                            <span class="font-bold text-[#102B51]">Rp{{ getSelectedPackage().price | number }}</span>
                        </div>

                        <!-- Add Ons -->
                        <div *ngIf="calculateAddonsTotal() > 0" class="space-y-1">
                            <div class="flex justify-between items-center text-emerald-700 font-medium">
                                <span>Add-On Fitur Extra ({{ getSelectedAddonsList().length }})</span>
                                <span class="font-bold">+Rp{{ calculateAddonsTotal() | number }}</span>
                            </div>
                            <div *ngFor="let addon of getSelectedAddonsList()"
                                class="pl-3 text-xs text-gray-500 flex justify-between">
                                <span class="truncate pr-2">
                                    • {{ addon.addonObj.name }}
                                    <strong *ngIf="addon.addonObj.hasQuantity">({{ addon.qty }} {{ addon.addonObj.unit
                                        }})</strong>
                                </span>
                                <span>+Rp{{ addon.totalPrice | number }}</span>
                            </div>
                        </div>

                        <!-- Voucher Discount -->
                        <div *ngIf="appliedDiscount > 0"
                            class="flex justify-between items-center text-rose-600 font-bold bg-rose-50 p-2.5 rounded-xl border border-rose-100 text-xs">
                            <span>Diskon Voucher ({{ appliedVoucherCode }})</span>
                            <span>-Rp{{ appliedDiscount | number }}</span>
                        </div>

                        <!-- Total Akhir -->
                        <div class="border-t border-gray-200 pt-3 mt-2 flex justify-between items-center">
                            <div>
                                <span class="text-xs uppercase font-extrabold text-gray-400 block tracking-wider">Total
                                    Akhir Pembayaran</span>
                                <span class="text-2xl font-black text-[#202367]">Rp{{ calculateFinalTotal() | number
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>

<!-- STEP 5: HALAMAN PEMBAYARAN VIEW -->
<div *ngIf="currentStep === 'payment'" class="animate-fade-in bg-[#F4F7FF] min-h-screen pb-16">

    <!-- Top Navigation Bar -->
    <section
        class="bg-gradient-to-r from-[#1B1E5B] to-[#202367] py-4 px-6 md:px-12 text-white shadow-md sticky top-[128px] z-40 backdrop-blur-md">
        <div class="max-w-7xl mx-auto flex items-center justify-between gap-4">
            <button (click)="backToCheckout()"
                class="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-full font-bold text-sm transition-all border border-white/20 cursor-pointer">
                <span>←</span>
                <span>Kembali ke Detail Pemesanan</span>
            </button>

            <div
                class="flex items-center gap-2 font-mono text-xs text-emerald-300 bg-white/10 px-3 py-1 rounded-full border border-white/20">
                <span>Kode Booking:</span>
                <span class="font-bold text-white">{{ bookingCode }}</span>
            </div>
        </div>
    </section>

    <!-- Main Payment Container (2-Column Layout matching Reference Image) -->
    <div class="max-w-7xl mx-auto px-6 md:px-12 py-10">

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

            <!-- LEFT COLUMN: Data Pemesanan & Rincian Tagihan (lg:col-span-6) -->
            <div class="lg:col-span-6 space-y-6">
                <div class="bg-white rounded-3xl p-6 sm:p-8 shadow-xl border border-gray-100 space-y-6">
                    <div>
                        <h2 class="text-2xl font-black text-[#102B51]">
                            Data <span class="text-[#202367]">Pemesanan</span>
                        </h2>
                        <div class="mt-3 text-sm text-gray-600 space-y-1 font-medium">
                            <p class="text-gray-800 font-bold">{{ customerEmail || 'test@test.com' }}</p>
                            <p class="text-gray-800 font-bold">{{ customerName || 'test' }}</p>
                            <p *ngIf="customerPhone" class="text-xs text-gray-500 font-medium">{{ customerPhone }}</p>
                        </div>
                    </div>

                    <!-- Selected Theme & Item Breakdown -->
                    <div class="border-t border-gray-100 pt-5 space-y-4">
                        <h3 class="text-lg font-extrabold text-[#202367]">
                            {{ selectedTheme?.title || 'Fallen Leave' }}
                        </h3>

                        <div class="flex justify-between items-center text-sm">
                            <span class="text-gray-600 font-medium">Harga</span>
                            <span class="font-bold text-[#102B51]">Rp. {{ getSelectedPackage().price | number }}</span>
                        </div>

                        <!-- Add On List -->
                        <div class="space-y-1.5 border-t border-dashed border-gray-200 pt-3">
                            <span class="text-sm font-extrabold text-[#202367] block">Add On</span>
                            <div class="pl-2 space-y-1 text-xs text-gray-600 font-medium">
                                <ng-container *ngIf="getSelectedAddonsList().length > 0">
                                    <div *ngFor="let addon of getSelectedAddonsList()" class="flex justify-between">
                                        <span class="capitalize">• {{ addon.addonObj.name }} <strong
                                                *ngIf="addon.addonObj.hasQuantity">({{ addon.qty }} {{
                                                addon.addonObj.unit }})</strong></span>
                                        <span class="font-semibold text-gray-800">+Rp. {{ addon.totalPrice | number
                                            }}</span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="getSelectedAddonsList().length === 0">
                                    <div class="text-gray-400 font-normal italic">• Tidak ada add-on dipilih</div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Diskon -->
                        <div *ngIf="appliedDiscount > 0"
                            class="flex justify-between items-center text-sm pt-2 text-rose-600 font-bold">
                            <span>Diskon</span>
                            <span>Rp. {{ appliedDiscount | number }}</span>
                        </div>

                        <!-- Total Pembayaran -->
                        <div class="border-t-2 border-gray-200 pt-4 mt-2 flex justify-between items-center">
                            <span class="text-lg font-extrabold text-[#102B51]">Total Pembayaran</span>
                            <span class="text-2xl font-black text-[#202367]">Rp. {{ calculateFinalTotal() | number
                                }},-</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- RIGHT COLUMN: Metode Pembayaran (QRIS Instant Only) -->
            <div class="lg:col-span-6 space-y-6">
                <div class="bg-white rounded-3xl p-6 sm:p-8 shadow-xl border border-gray-100 space-y-6">
                    <div class="flex items-center justify-between">
                        <h2 class="text-xl font-black text-[#102B51]">
                            Metode <span class="text-[#202367]">Pembayaran</span>
                        </h2>
                        <span
                            class="text-xs font-black uppercase bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full border border-emerald-200">
                            QRIS INSTANT
                        </span>
                    </div>

                    <!-- Single Payment Card: QRIS Instant & Barcode Scanner -->
                    <div
                        class="border-2 border-[#202367] bg-[#F4F7FF] rounded-2xl p-6 shadow-md relative overflow-hidden space-y-5">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-3">
                                <div
                                    class="w-12 h-12 rounded-2xl bg-[#202367] text-white flex items-center justify-center text-xl font-black shadow-sm">
                                    📱
                                </div>
                                <div>
                                    <h3 class="text-base font-extrabold text-[#102B51]">QRIS (Quick Response Code
                                        Indonesian Standard)</h3>
                                    <p class="text-xs text-gray-500 font-medium">BCA, Mandiri, BNI, BRI, GoPay, OVO,
                                        Dana, ShopeePay & Semua E-Wallet</p>
                                </div>
                            </div>
                            <span
                                class="w-6 h-6 rounded-full bg-emerald-500 text-white flex items-center justify-center text-xs font-black shrink-0">
                                ✓
                            </span>
                        </div>

                        <!-- Countdown Timer Box -->
                        <div *ngIf="!isPaymentSuccess()"
                            class="bg-amber-500/10 border border-amber-500/20 rounded-2xl p-4 flex items-center justify-between shadow-xs">
                            <div class="flex items-center gap-3">
                                <div
                                    class="w-10 h-10 rounded-xl bg-amber-500/20 text-amber-600 flex items-center justify-center text-xl shrink-0 font-bold">
                                    ⏱️
                                </div>
                                <div>
                                    <h4 class="text-xs font-black text-[#102B51] uppercase tracking-wider">Sisa Waktu
                                        Pembayaran</h4>
                                    <p class="text-[11px] text-gray-500 font-medium">Selesaikan pembayaran sebelum QR
                                        expired</p>
                                </div>
                            </div>
                            <div class="text-right">
                                <span class="text-2xl font-black font-mono text-amber-600 tracking-wider">
                                    {{ formattedPaymentTimer }}
                                </span>
                            </div>
                        </div>

                        <!-- QRIS Barcode Box Container (Swaps to Success View when Paid) -->
                        <div *ngIf="!isPaymentSuccess(); else paymentSuccessContainer"
                            class="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center justify-center text-center space-y-4">
                            <!-- Official QRIS Header Badge -->
                            <div class="flex items-center justify-between w-full border-b border-gray-100 pb-3">
                                <div class="flex items-center gap-2">
                                    <span
                                        class="text-xs font-black text-[#102B51] uppercase tracking-wider">MERCHANT:</span>
                                    <span class="text-xs font-extrabold text-[#202367]">VISIDEA STUDIO</span>
                                </div>
                                <span
                                    class="text-[10px] font-bold bg-rose-50 text-rose-700 px-2 py-0.5 rounded-md border border-rose-200 uppercase">
                                    QRIS Resmi
                                </span>
                            </div>

                            <!-- QR Code Image Container -->
                            <div
                                class="p-3 bg-white border-2 border-slate-900 rounded-2xl shadow-md relative group flex items-center justify-center">
                                <!-- Hidden canvas used internally by QRCode library -->
                                <canvas #qrisCanvas class="hidden"></canvas>
                                <!-- Displayed QR image -->
                                <ng-container *ngIf="qrisDataUrl; else qrLoading">
                                    <img [src]="qrisDataUrl" alt="QR Code QRIS"
                                        class="w-56 h-56 md:w-64 md:h-64 object-contain rounded-lg" />
                                </ng-container>
                                <ng-template #qrLoading>
                                    <div
                                        class="w-56 h-56 md:w-64 md:h-64 flex flex-col items-center justify-center gap-2">
                                        <svg class="animate-spin w-8 h-8 text-[#102B51]"
                                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z">
                                            </path>
                                        </svg>
                                        <span class="text-xs text-gray-400 font-medium">Memuat QR...</span>
                                    </div>
                                </ng-template>
                            </div>

                            <div class="space-y-1">
                                <p class="text-xs font-extrabold text-[#102B51]">Scan Barcode untuk Pembayaran</p>
                                <p class="text-[11px] text-gray-500 font-medium">Buka m-Banking BCA, Mandiri, BNI, BRI
                                    atau E-Wallet lalu arahkan kamera ke barcode di atas</p>
                                <button (click)="copyQrisString()"
                                    class="mt-2 px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-bold rounded-lg transition-colors inline-flex items-center gap-1.5 cursor-pointer">
                                    <span>📋 Salin String Payload QRIS</span>
                                </button>
                                <div *ngIf="copiedToastMsg"
                                    class="text-xs font-bold text-emerald-600 animate-pulse mt-1">
                                    {{ copiedToastMsg }}
                                </div>
                            </div>
                        </div>

                        <!-- Success View Container -->
                        <ng-template #paymentSuccessContainer>
                            <div
                                class="bg-emerald-500/10 border-2 border-emerald-500/30 p-8 rounded-3xl text-center space-y-4 shadow-xl animate-fade-in">
                                <div
                                    class="w-20 h-20 bg-emerald-500 text-white rounded-full flex items-center justify-center text-4xl font-black mx-auto shadow-lg">
                                    ✓
                                </div>
                                <div>
                                    <span
                                        class="bg-emerald-500 text-white text-[10px] font-extrabold px-3 py-1 rounded-full uppercase tracking-wider">
                                        TRANSAKSI SUCCESS / LUNAS
                                    </span>
                                    <h3 class="text-2xl font-black text-[#102B51] mt-2">Pembayaran Berhasil!</h3>
                                    <p class="text-xs text-gray-600 font-medium max-w-sm mx-auto mt-1">
                                        Pembayaran QRIS Anda sebesar <strong class="text-emerald-700">Rp{{
                                            (createdOrderData?.payment?.amount || calculateFinalTotal()) | number
                                            }}</strong> telah terverifikasi secara otomatis oleh sistem.
                                    </p>
                                </div>

                                <div
                                    class="bg-white p-4 rounded-2xl border border-emerald-200 text-xs space-y-2 text-left shadow-xs">
                                    <div class="flex justify-between items-center">
                                        <span class="text-gray-500 font-medium">Status QR:</span>
                                        <span class="font-extrabold text-emerald-600 uppercase">BERHASIL DIBAYAR</span>
                                    </div>
                                    <div *ngIf="createdOrderData?.order_code" class="flex justify-between items-center">
                                        <span class="text-gray-500 font-medium">Kode Order:</span>
                                        <span class="font-mono font-bold text-[#102B51]">{{ createdOrderData.order_code
                                            }}</span>
                                    </div>
                                    <div *ngIf="createdOrderData?.payment?.reference_id"
                                        class="flex justify-between items-center">
                                        <span class="text-gray-500 font-medium">Ref ID:</span>
                                        <span class="font-mono text-xs text-gray-700">{{
                                            createdOrderData.payment.reference_id }}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Payment Details -->
                        <div class="bg-white p-4 rounded-xl border border-gray-200 text-xs space-y-2 text-gray-700">
                            <div class="flex justify-between items-center">
                                <span class="font-semibold text-gray-500">Status Transaksi:</span>
                                <div class="flex items-center gap-1.5">
                                    <span *ngIf="isPaymentSuccess()"
                                        class="font-black text-emerald-600 uppercase flex items-center gap-1">
                                        ✓ LUNAS (PAID)
                                    </span>
                                    <span *ngIf="!isPaymentSuccess()"
                                        class="font-extrabold text-amber-600 uppercase flex items-center gap-1.5">
                                        <span class="w-2 h-2 rounded-full bg-amber-500 animate-pulse"></span>
                                        MENUNGGU PEMBAYARAN (PENDING)
                                        <button (click)="checkPaymentStatusApi(true)"
                                            [disabled]="isCheckingPaymentStatus"
                                            class="ml-2 px-2.5 py-1 bg-amber-50 hover:bg-amber-100 border border-amber-200 text-amber-800 font-extrabold text-[11px] rounded-lg transition-all inline-flex items-center gap-1 cursor-pointer shadow-2xs active:scale-95">
                                            <span *ngIf="isCheckingPaymentStatus"
                                                class="w-3 h-3 border-2 border-amber-800 border-t-transparent rounded-full animate-spin"></span>
                                            <span>🔄 Cek Status</span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Instructions -->
                        <p *ngIf="!isPaymentSuccess()" class="text-xs text-gray-600 leading-relaxed font-medium">
                            Pembayaran diproses secara instan melalui sistem Visidea Studio. Klik tombol di bawah untuk
                            menyelesaikan pembayaran & konfirmasi order Anda.
                        </p>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>

<!-- Quantity Stepper Pop-up Modal (Matches Image 4) -->
<div *ngIf="isAddonQtyModalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs animate-fade-in">
    <div
        class="bg-white rounded-3xl max-w-sm w-full p-6 shadow-2xl border border-gray-100 text-center space-y-5 relative animate-scale-up">

        <!-- Add-on Title with colored words -->
        <div>
            <h3 class="text-xl font-extrabold text-[#102B51]">
                {{ activeModalAddon?.name }}
            </h3>
            <p class="text-xs text-gray-500 mt-1 leading-relaxed">
                {{ activeModalAddon?.desc }}
            </p>
        </div>

        <!-- Quantity Stepper Control Box -->
        <div class="bg-[#F4F7FF] p-4 rounded-2xl border border-gray-200 flex items-center justify-center gap-6">
            <button (click)="decreaseModalQty()"
                class="w-10 h-10 rounded-full bg-white text-[#202367] font-black text-xl shadow-md border border-gray-200 hover:bg-gray-100 flex items-center justify-center cursor-pointer active:scale-95 transition-transform">
                -
            </button>

            <div class="text-2xl font-black text-[#102B51] min-w-[60px]">
                {{ modalQty }}
                <span class="text-xs font-bold text-gray-500 block text-center">{{ activeModalAddon?.unit }}</span>
            </div>

            <button (click)="increaseModalQty()"
                class="w-10 h-10 rounded-full bg-white text-[#202367] font-black text-xl shadow-md border border-gray-200 hover:bg-gray-100 flex items-center justify-center cursor-pointer active:scale-95 transition-transform">
                +
            </button>
        </div>

        <!-- Subtotal Preview -->
        <div class="bg-emerald-50 p-3 rounded-xl border border-emerald-100 flex justify-between items-center text-xs">
            <span class="text-emerald-800 font-medium">Subtotal Add-on:</span>
            <span class="text-base font-black text-emerald-600">Rp{{ (activeModalAddon?.unitPrice || 0) * modalQty |
                number }}</span>
        </div>

        <!-- Action Buttons -->
        <div class="space-y-2 pt-1">
            <button (click)="confirmAddonModal()"
                class="w-full py-3.5 bg-[#202367] hover:bg-[#1a1d52] text-white font-extrabold rounded-2xl text-sm shadow-lg transition-colors cursor-pointer">
                {{ isAddonSelected(activeModalAddon?.id) ? 'Simpan Perubahan Add on' : 'Tambah Add on' }}
            </button>

            <button *ngIf="isAddonSelected(activeModalAddon?.id)" (click)="cancelCurrentModalAddon()"
                class="w-full py-3 bg-rose-50 hover:bg-rose-100 text-rose-600 font-bold rounded-2xl text-xs border border-rose-200 transition-colors cursor-pointer flex items-center justify-center gap-1.5">
                <span>Batalkan Add-On Ini</span>
            </button>

            <button (click)="closeAddonQtyModal()"
                class="w-full py-2.5 text-gray-400 hover:text-gray-600 font-bold text-xs cursor-pointer">
                Tutup
            </button>
        </div>

    </div>
</div>

<!-- Payment Success Pop-up Modal -->
<div *ngIf="isPaymentSuccessModalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-fade-in">
    <div
        class="bg-white rounded-3xl max-w-sm w-full p-6 shadow-2xl border border-emerald-100 text-center space-y-5 relative animate-scale-up">
        <div
            class="w-16 h-16 bg-emerald-500 text-white rounded-full flex items-center justify-center text-3xl font-black mx-auto shadow-lg">
            ✓
        </div>
        <div>
            <h3 class="text-xl font-extrabold text-[#102B51]">Pembayaran Berhasil!</h3>
            <p class="text-xs text-gray-600 mt-1.5 leading-relaxed">
                Transaksi Anda dengan Kode Order <strong class="text-[#202367]">{{ createdOrderData?.order_code ||
                    bookingCode }}</strong> telah lunas dan diverifikasi oleh sistem.
            </p>
        </div>
        <div class="bg-emerald-50 p-3 rounded-2xl border border-emerald-100 text-xs text-emerald-800 font-semibold">
            Status: <span class="uppercase font-black text-emerald-600">PAID / LUNAS</span>
        </div>

        <div class="space-y-2 pt-1">
            <!-- View Invoice Button -->
            <button (click)="openInvoiceModal()"
                class="w-full py-3.5 bg-emerald-600 hover:bg-emerald-700 text-white font-extrabold rounded-2xl text-sm shadow-lg transition-all flex items-center justify-center gap-2 cursor-pointer active:scale-95">
                <span>📄 Lihat & Cetak Invoice</span>
            </button>

            <button (click)="closePaymentSuccessModal()"
                class="w-full py-3 bg-[#202367] hover:bg-[#1a1d52] text-white font-bold rounded-2xl text-xs transition-colors cursor-pointer">
                Selesai & Lihat Status
            </button>
        </div>
    </div>
</div>

<!-- OFFICIAL INVOICE MODAL -->
<div *ngIf="isInvoiceModalOpen"
    class="fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-6 bg-black/75 backdrop-blur-md animate-fade-in overflow-y-auto">
    <div
        class="bg-white rounded-3xl max-w-2xl w-full shadow-2xl border border-gray-200 overflow-hidden my-6 relative animate-scale-up flex flex-col">

        <!-- Invoice Modal Action Header (Excluded on Print) -->
        <div
            class="bg-gradient-to-r from-[#102B51] to-[#202367] p-4 sm:p-5 text-white flex items-center justify-between print:hidden">
            <div class="flex items-center gap-2.5">
                <span class="text-2xl">📄</span>
                <div>
                    <h3 class="text-base sm:text-lg font-extrabold">Invoice Resmi Transaksi</h3>
                    <p class="text-xs text-emerald-300 font-medium">PT Adhikari Inovasi Indonesia • Visidea Studio</p>
                </div>
            </div>

            <div class="flex items-center gap-2">
                <button (click)="printInvoice()"
                    class="bg-white/15 hover:bg-white/25 text-white text-xs font-bold px-3.5 py-2 rounded-xl border border-white/20 transition flex items-center gap-1.5 cursor-pointer">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    <span>Cetak / PDF</span>
                </button>

                <button (click)="closeInvoiceModal()"
                    class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition cursor-pointer">
                    ✕
                </button>
            </div>
        </div>

        <!-- Printable Invoice Content Area -->
        <div id="printableInvoice" class="p-6 sm:p-8 bg-white space-y-6 text-gray-800 text-xs sm:text-sm">

            <!-- Company & Invoice Header Row -->
            <div class="flex flex-col sm:flex-row justify-between items-start gap-4 pb-6 border-b-2 border-gray-100">
                <div class="space-y-1.5">
                    <div class="flex items-center gap-2">
                        <img src="/assets/visidea/logo/logo-visidea.png" class="h-8 object-contain" alt="Visidea Logo"
                            onerror="this.style.display='none'">
                        <span class="text-xl font-black tracking-tight text-[#102B51]">VISIDEA STUDIO</span>
                    </div>
                    <p class="text-xs text-gray-500 max-w-xs leading-relaxed">
                        Creative Event Solutions & Digital Invitation Provider<br>
                        Bandung, Jawa Barat, Indonesia<br>
                        WhatsApp: +62 822-6008-4847
                    </p>
                </div>

                <div class="sm:text-right space-y-1">
                    <span
                        class="bg-emerald-100 text-emerald-800 text-xs font-black px-3 py-1 rounded-full uppercase inline-block border border-emerald-300">
                        ✓ PAID / LUNAS
                    </span>
                    <h4 class="text-base sm:text-lg font-extrabold text-[#102B51] mt-1">{{ invoiceData?.invoiceNumber }}
                    </h4>
                    <p class="text-xs text-gray-500">Tanggal: {{ invoiceData?.invoiceDate }}</p>
                    <p class="text-xs text-gray-500">Order ID: <strong class="text-gray-700">{{ invoiceData?.orderCode
                            }}</strong></p>
                </div>
            </div>

            <!-- Customer & Billing Information -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 rounded-2xl bg-[#F8FAFC] border border-gray-100">
                <div>
                    <span class="text-[11px] font-bold text-gray-400 uppercase tracking-wider block mb-1">Ditagihkan
                        Kepada:</span>
                    <h5 class="text-sm font-extrabold text-[#102B51]">{{ invoiceData?.customerName }}</h5>
                    <p class="text-xs text-gray-600 mt-0.5">{{ invoiceData?.customerPhone }}</p>
                    <p class="text-xs text-gray-600">{{ invoiceData?.customerEmail }}</p>
                </div>

                <div class="sm:text-right">
                    <span class="text-[11px] font-bold text-gray-400 uppercase tracking-wider block mb-1">Metode &
                        Status Pembayaran:</span>
                    <p class="text-xs font-bold text-emerald-700">{{ invoiceData?.paymentMethod }}</p>
                    <p class="text-[11px] text-gray-500 mt-0.5">Status: <strong class="text-emerald-600 font-bold">Lunas
                            (Otomatis Terverifikasi)</strong></p>
                    <p class="text-[11px] text-gray-500">Preset: {{ invoiceData?.selectedReligion }} • {{
                        invoiceData?.selectedColorScheme }}</p>
                </div>
            </div>

            <!-- Itemized Table -->
            <div class="overflow-x-auto">
                <table class="w-full text-left border-collapse">
                    <thead>
                        <tr
                            class="border-b border-gray-200 text-gray-500 text-[11px] uppercase tracking-wider font-extrabold">
                            <th class="py-3 px-2">Deskripsi Produk / Layanan</th>
                            <th class="py-3 px-2 text-center">Kategori</th>
                            <th class="py-3 px-2 text-center">Qty</th>
                            <th class="py-3 px-2 text-right">Harga</th>
                            <th class="py-3 px-2 text-right">Subtotal</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100 text-xs">
                        <!-- Main Package & Theme Row -->
                        <tr class="hover:bg-gray-50/60">
                            <td class="py-3 px-2 font-bold text-[#102B51]">
                                {{ invoiceData?.packageName }} — Tema: {{ invoiceData?.themeTitle }}
                                <span class="block text-[11px] font-normal text-gray-500 mt-0.5">
                                    Undangan Digital dengan custom nama tamu unlimited, RSVP, peta & amplop digital
                                </span>
                            </td>
                            <td class="py-3 px-2 text-center text-gray-500">{{ invoiceData?.themeCategory }}</td>
                            <td class="py-3 px-2 text-center font-bold">1</td>
                            <td class="py-3 px-2 text-right">Rp{{ invoiceData?.packagePrice | number }}</td>
                            <td class="py-3 px-2 text-right font-bold text-[#102B51]">Rp{{ invoiceData?.packagePrice |
                                number }}</td>
                        </tr>

                        <!-- Addons Rows -->
                        <tr *ngFor="let addon of invoiceData?.selectedAddons" class="hover:bg-gray-50/60">
                            <td class="py-3 px-2 font-medium text-gray-700">
                                Add-on: {{ addon.addonObj.name }}
                                <span *ngIf="addon.addonObj.hasQuantity" class="text-[11px] text-gray-400 block">
                                    ({{ addon.qty }} {{ addon.addonObj.unit }})
                                </span>
                            </td>
                            <td class="py-3 px-2 text-center text-gray-500">Add-on</td>
                            <td class="py-3 px-2 text-center font-bold">{{ addon.qty }}</td>
                            <td class="py-3 px-2 text-right">Rp{{ addon.unitPrice | number }}</td>
                            <td class="py-3 px-2 text-right font-bold text-gray-700">+Rp{{ addon.totalPrice | number }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Total Calculations Breakdown -->
            <div
                class="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4 pt-4 border-t-2 border-gray-100">
                <!-- Payment Verification Seal -->
                <div class="flex items-center gap-3 p-3 rounded-xl bg-emerald-50/80 border border-emerald-200/60">
                    <div
                        class="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center font-black text-lg">
                        ✓
                    </div>
                    <div>
                        <span class="text-xs font-bold text-emerald-900 block">VISIDEA OFFICIAL VERIFIED</span>
                        <span class="text-[10px] text-emerald-700">Bukti pembayaran sah & otomatis tersimpan.</span>
                    </div>
                </div>

                <!-- Price Summary Box -->
                <div class="w-full sm:w-64 space-y-1.5 text-xs">
                    <div *ngIf="invoiceData?.discountAmount > 0"
                        class="flex justify-between text-rose-600 font-semibold">
                        <span>Diskon Promo ({{ invoiceData?.voucherCode }}):</span>
                        <span>-Rp{{ invoiceData?.discountAmount | number }}</span>
                    </div>
                    <div
                        class="flex justify-between items-baseline pt-2 border-t border-gray-200 font-extrabold text-sm text-[#102B51]">
                        <span>Total Pembayaran:</span>
                        <span class="text-lg sm:text-xl text-emerald-600 font-black">
                            Rp{{ invoiceData?.totalAmount | number }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Footer Notes & Watermark -->
            <div class="pt-4 border-t border-gray-100 text-center text-gray-400 text-[11px] space-y-1">
                <p>Terima kasih telah mempercayakan Visidea Studio untuk momen istimewa Anda.</p>
                <p>Untuk bantuan atau konsultasi teknis, silakan hubungi Customer Support kami via WhatsApp.</p>
            </div>
        </div>

        <!-- Invoice Modal Bottom Action Buttons (Print / Close) -->
        <div class="p-4 bg-gray-50 border-t border-gray-100 flex flex-wrap gap-3 justify-end print:hidden">
            <button (click)="closeInvoiceModal()"
                class="px-5 py-2.5 rounded-xl border border-gray-300 hover:bg-gray-100 text-gray-700 text-xs font-bold transition cursor-pointer">
                Tutup
            </button>
            <button (click)="printInvoice()"
                class="px-6 py-2.5 bg-[#202367] hover:bg-[#161845] text-white text-xs font-extrabold rounded-xl shadow-md transition flex items-center gap-2 cursor-pointer active:scale-95">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                <span>Cetak / Unduh PDF</span>
            </button>
        </div>

    </div>
</div>

<!-- Modal Pilih Format Agama (Identical with Home Page Selection Modal) -->
<div *ngIf="isDemoModalOpen"
    class="fixed inset-0 z-[130] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
    <div
        class="relative w-full max-w-lg bg-white rounded-3xl shadow-2xl border border-slate-100 p-6 sm:p-8 overflow-hidden">

        <!-- Close Button Top Right -->
        <button (click)="closeDemoModal()"
            class="absolute top-5 right-5 text-slate-400 hover:text-slate-700 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>

        <!-- Header -->
        <div class="mb-6 pr-8">
            <div class="flex items-center gap-2 mb-2">
                <span class="w-2 h-2 rounded-full bg-[#102B51]"></span>
                <span class="text-[10px] sm:text-[11px] font-bold tracking-[0.15em] text-[#102B51] uppercase">VISIDEA
                    DIGITAL INVITATION</span>
            </div>
            <h3 class="text-xl sm:text-2xl font-bold text-[#102B51] tracking-tight">
                Pilih Format Agama
            </h3>
            <p class="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
                Pilih format agama untuk menampilkan tata cara dan kutipan doa yang sesuai pada demo undangan.
            </p>
        </div>

        <!-- Religion Selection Options (Clean 2-Column Grid matching Home) -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-6">
            <button *ngFor="let rel of religions" type="button" (click)="selectAgama(rel.id)" [class]="'flex items-center justify-between p-3.5 rounded-xl border text-left transition-all duration-150 cursor-pointer ' +
                         (selectedReligion === rel.id 
                            ? 'bg-[#F4F8FE] border-[#102B51] text-[#102B51] shadow-sm ring-1 ring-[#102B51]' 
                            : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50')">
                <div class="flex items-center gap-3">
                    <!-- Custom Radio Indicator -->
                    <div [class]="'w-4 h-4 rounded-full border flex items-center justify-center shrink-0 ' + 
                                 (selectedReligion === rel.id ? 'border-[#102B51]' : 'border-slate-300')">
                        <div *ngIf="selectedReligion === rel.id" class="w-2 h-2 rounded-full bg-[#102B51]"></div>
                    </div>
                    <div>
                        <div class="text-xs sm:text-sm font-semibold tracking-tight">{{ rel.name || rel.label }}</div>
                        <div class="text-[10px] sm:text-[11px] text-slate-400 mt-0.5">{{ rel.ceremony }}</div>
                    </div>
                </div>

                <!-- Subtle Check Indicator for Selected Item -->
                <svg *ngIf="selectedReligion === rel.id" class="w-4 h-4 text-[#102B51] shrink-0" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                </svg>
            </button>
        </div>

        <!-- Current Selected Theme Info Preview -->
        <div *ngIf="selectedDemoItem"
            class="flex items-center justify-between py-2.5 px-3.5 bg-slate-50 rounded-xl border border-slate-100 text-xs mb-5">
            <span class="text-slate-500">Tema Desain:</span>
            <span class="font-semibold text-[#102B51]">{{ selectedDemoItem.title }}</span>
        </div>

        <!-- Action Buttons Footer -->
        <div class="flex items-center gap-3">
            <button type="button" (click)="closeDemoModal()"
                class="py-3 px-5 rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-600 text-xs sm:text-sm font-medium transition-colors cursor-pointer">
                Batal
            </button>
            <button type="button" (click)="confirmAgamaAndOpenDemo()"
                class="flex-1 py-3 px-5 rounded-xl bg-[#102B51] hover:bg-[#1A3D6E] text-white text-xs sm:text-sm font-semibold tracking-wide flex items-center justify-center gap-2 shadow-sm hover:shadow transition-all active:scale-[0.99] cursor-pointer">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <span>Lihat Demo Undangan</span>
            </button>
        </div>



    </div>
</div>

<!-- MODAL: REQUEST CUSTOM EVENT INVITATION -->
<div *ngIf="isCustomEventModalOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-[#0A0E1A]/70 backdrop-blur-sm animate-fade-in"
    (click)="closeCustomEventModal()">

    <div class="relative w-full max-w-xl bg-white rounded-3xl p-6 sm:p-8 shadow-2xl border border-slate-100 overflow-hidden max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">

        <!-- Top Accent Line -->
        <div class="absolute top-0 inset-x-0 h-1.5 bg-gradient-to-r from-[#202367] via-emerald-500 to-[#102B51]"></div>

        <!-- Close Button -->
        <button (click)="closeCustomEventModal()" aria-label="Tutup"
            class="absolute top-5 right-5 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 hover:text-slate-800 flex items-center justify-center transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>

        <!-- Modal Header -->
        <div class="mb-6 pr-8">
            <div
                class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2">
                <span>Custom Event Request</span>
            </div>
            <h3 class="text-xl sm:text-2xl font-black text-[#102B51] tracking-tight">
                Request Custom Event Invitation
            </h3>
            <p class="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
                Tentukan konsep acara, tema desain yang diinginkan, warna palet, dan lampirkan link referensi desain
                Anda.
            </p>
        </div>

        <!-- Form Fields -->
        <form (ngSubmit)="submitCustomEventRequest()" class="space-y-4">

            <!-- 1. Nama Acara & Jenis Acara -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Nama Acara <span class="text-rose-500">*</span>
                    </label>
                    <input type="text" [(ngModel)]="customEventForm.eventName" name="eventName"
                        placeholder="Cth: Sweet 17 Chelsea / Grand Opening Cafe" required
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>

                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Jenis Acara
                    </label>
                    <select [(ngModel)]="customEventForm.eventType" name="eventType"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition bg-white">
                        <option value="Ulang Tahun / Sweet 17">Ulang Tahun / Sweet 17</option>
                        <option value="Grand Opening / Peresmian">Grand Opening / Peresmian</option>
                        <option value="Reuni Alumni / Gathering">Reuni Alumni / Gathering</option>
                        <option value="Akikah / Baby Shower">Akikah / Baby Shower</option>
                        <option value="Anniversary & Perayaan Lainnya">Anniversary & Lainnya</option>
                    </select>
                </div>
            </div>

            <!-- 2. Konsep Tema & Palet Warna -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Konsep / Tema Desain
                    </label>
                    <input type="text" [(ngModel)]="customEventForm.conceptTheme" name="conceptTheme"
                        placeholder="Cth: Cyberpunk Neon, Vintage 90s, Pastel Cute"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>

                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Warna Utama / Palet Pilihan
                    </label>
                    <input type="text" [(ngModel)]="customEventForm.colorPalette" name="colorPalette"
                        placeholder="Cth: Emerald Green & Gold, Lilac Pastel"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
            </div>

            <!-- 3. Link Referensi Desain -->
            <div>
                <label class="block text-xs font-bold text-slate-700 mb-1.5">
                    Link Referensi Desain / Inspirasi
                </label>
                <input type="text" [(ngModel)]="customEventForm.designReference" name="designReference"
                    placeholder="Link Pinterest, Instagram, Google Drive, Canva, atau deskripsi singkat"
                    class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
            </div>

            <!-- 4. Catatan Tambahan / Fitur Khusus -->
            <div>
                <label class="block text-xs font-bold text-slate-700 mb-1.5">
                    Catatan Tambahan & Kebutuhan Khusus
                </label>
                <textarea [(ngModel)]="customEventForm.specialNotes" name="specialNotes" rows="2"
                    placeholder="Cth: Butuh QR Code barcode check-in tamu, dresscode putih, countdown timer acara..."
                    class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition resize-none"></textarea>
            </div>

            <!-- 5. Kontak Pemesan -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 border-t border-slate-100">
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        Nama Anda
                    </label>
                    <input type="text" [(ngModel)]="customEventForm.contactName" name="contactName"
                        placeholder="Nama lengkap pemesan"
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
                <div>
                    <label class="block text-xs font-bold text-slate-700 mb-1.5">
                        No. WhatsApp Kontak <span class="text-rose-500">*</span>
                    </label>
                    <input type="tel" [(ngModel)]="customEventForm.contactPhone" name="contactPhone"
                        placeholder="08xxxxxxxxxx" required
                        class="w-full px-3.5 py-2.5 rounded-xl border border-slate-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/10 text-xs sm:text-sm outline-none transition">
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="flex items-center gap-3 pt-4">
                <button type="button" (click)="closeCustomEventModal()"
                    class="py-3 px-5 rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-600 text-xs sm:text-sm font-semibold transition cursor-pointer">
                    Batal
                </button>
                <button type="submit"
                    class="flex-1 py-3 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-xs sm:text-sm tracking-wide flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all active:scale-[0.99] cursor-pointer">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    <span>Kirim Request & Konsultasi WA</span>
                </button>
            </div>

        </form>

    </div>
</div>

<!-- FULLSCREEN DEMO MODAL WITH SMARTPHONE FRAME -->
<!-- Debug: Modal will show when isFullscreenDemoOpen = true -->
<div *ngIf="isFullscreenDemoOpen"
    class="fixed inset-0 z-[9999] bg-slate-900/95 backdrop-blur-sm flex items-center justify-center p-4"
    (click)="closeFullscreenDemo()" style="display: flex !important;">

    <!-- Smartphone Frame Container -->
    <div class="relative flex flex-col items-center gap-4" (click)="$event.stopPropagation()">

        <!-- Smartphone Frame Mockup -->
        <div class="relative w-full max-w-[380px] h-[780px] bg-gradient-to-br from-slate-800 via-slate-900 to-black rounded-[3rem] shadow-2xl p-3 border-[14px] border-slate-900"
            style="box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), inset 0 2px 4px 0 rgba(255, 255, 255, 0.06);">

            <!-- Phone Notch/Camera -->
            <div
                class="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-7 bg-slate-900 rounded-b-3xl z-20 flex items-center justify-center">
                <div class="w-16 h-1.5 bg-slate-800 rounded-full"></div>
            </div>

            <!-- Screen Container -->
            <div class="relative w-full h-full bg-white rounded-[2.5rem] overflow-hidden shadow-inner">

                <!-- Loading Spinner -->
                <div *ngIf="isFullscreenDemoLoading"
                    class="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 z-10">
                    <div
                        class="w-16 h-16 border-4 border-[#102B51] border-t-transparent rounded-full animate-spin mb-4">
                    </div>
                    <p class="text-slate-600 text-sm font-medium">Memuat demo undangan...</p>
                    <p class="text-slate-400 text-xs mt-2">Mohon tunggu sebentar</p>
                </div>

                <!-- Demo Iframe -->
                <iframe *ngIf="fullscreenDemoUrl" [src]="fullscreenDemoUrl" (load)="onFullscreenDemoLoad()"
                    (error)="onFullscreenDemoError()" class="w-full h-full border-0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>

                <!-- Iframe Blocked/Error Message -->
                <div *ngIf="!isFullscreenDemoLoading"
                    class="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-gradient-to-br from-slate-100 to-slate-200 p-6 text-center">
                    <div class="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
                        <svg class="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-lg font-bold text-slate-700 mb-2">Preview Tidak Dapat Ditampilkan</h3>
                        <p class="text-sm text-slate-600 mb-4 max-w-xs">
                            Website undangan memblokir preview iframe. Silakan buka di tab baru untuk melihat demo
                            lengkap.
                        </p>
                        <button type="button" (click)="openDemoInNewTabFromFullscreen()"
                            class="px-6 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-sm transition-all shadow-lg inline-flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            <span>Buka di Tab Baru</span>
                        </button>
                    </div>
                </div>

            </div>

            <!-- Phone Home Button Indicator -->
            <div class="absolute bottom-2 left-1/2 -translate-x-1/2 w-32 h-1 bg-slate-700 rounded-full"></div>
        </div>

        <!-- Control Buttons Below Phone -->
        <div class="flex items-center gap-3">
            <button type="button" (click)="closeFullscreenDemo()"
                class="px-6 py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-semibold text-sm transition-all shadow-lg border border-slate-700 flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span>Tutup Preview</span>
            </button>

            <button type="button" (click)="openDemoInNewTabFromFullscreen()"
                class="px-6 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-sm transition-all shadow-lg flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                <span>Buka di Tab Baru</span>
            </button>
        </div>

        <!-- Info Text -->
        <p class="text-slate-400 text-xs text-center max-w-md">
            Ini adalah preview demo. Jika tidak muncul, klik "Buka di Tab Baru" untuk melihat di browser.
        </p>
    </div>

</div>